import React from 'react';
import {
  Box,
  Button,
  Card,
  Link,
  Stack,
  useTheme,
} from '@mui/material';
import {
  ContextMenu,
  ContextMenuButton,
  ContextMenuItem,
  ProfileCardContent,
  LabelAndValueElement,
  getFormattedDateShortMonthDDYYYY,
  ZAvatar,
} from '@marageti/z4-lib';
import { ProfileCardProps } from '../types';
import {
  getPartnerPrimaryPhoneNumber,
  getPartnerSMSPhoneNumber,
  getPartnerUSPhoneNumber,
} from '../../../../utils/helpers';
import stylesT from '../styles';

const ProfileButton = ({
  children,
  href,
}: any) => {
  const theme = useTheme();
  const styles = stylesT(theme);
  const btn = (
    <Button
      variant="outlined"
      disabled={!href}
      role="button"
    >
      {children}
    </Button>
  );
  return !href ? btn : (
    <Link
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      sx={styles.profileButtonLink}
    >
      {btn}
    </Link>
  );
};

const ProfileCard = ({
  contextMenuAnchor,
  contextMenuOpen,
  onCloseContextMenu,
  onEditAvatar,
  onOpenContextMenu,
  onOpenEditor,
  partner,
}: ProfileCardProps) => {
  const theme = useTheme();
  const styles = stylesT(theme);
  const menuId = 'profile-context-menu';
  const buttonId = 'profile-context-button';
  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Box sx={styles.avatarBox}>
          <ZAvatar
            name={partner?.name}
            size={128}
            loading={!partner}
            onEdit={onEditAvatar}
            src={partner?.avatar}
          />
        </Box>
        <Stack spacing="24px" width="100%">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <LabelAndValueElement
              title="Name"
              value={partner?.name || '-'}
              key="name"
            />
            <ContextMenuButton
              id={buttonId}
              open={contextMenuOpen}
              onClick={onOpenContextMenu}
              menuId={menuId}
            />
            <ContextMenu
              anchorEl={contextMenuAnchor}
              buttonId={buttonId}
              id={menuId}
              onClose={onCloseContextMenu}
              open={contextMenuOpen}
            >
              <ContextMenuItem onClick={onOpenEditor}>
                Edit
              </ContextMenuItem>
            </ContextMenu>
          </Stack>
          <LabelAndValueElement
            title="Onboarded"
            value={partner ? getFormattedDateShortMonthDDYYYY(partner?.onboardedOn) || '-' : undefined}
            key="onboarded"
          />
          <LabelAndValueElement
            title="Founded"
            value={partner && (partner.yearFounded || '-')}
            key="founded"
          />
          <LabelAndValueElement
            title="US Phone"
            value={getPartnerUSPhoneNumber(partner)}
            key="us-phone"
          />
          <LabelAndValueElement
            title="Primary Phone"
            value={getPartnerPrimaryPhoneNumber(partner)}
            key="primary-phone"
          />
          <LabelAndValueElement
            title="SMS Number"
            value={getPartnerSMSPhoneNumber(partner)}
            key="sms-number"
          />
          <LabelAndValueElement
            title="Email"
            value={partner && (partner?.email || '-')}
            key="email"
          />
          <LabelAndValueElement
            title="Website"
            value={partner && (partner?.website || '-')}
            key="website"
          />
          <Stack
            spacing={{
              mobile: '24px',
              desktop: '16px',
            }}
            direction={{
              mobile: 'column',
              desktop: 'row',
            }}
            justifyContent="space-between"
          >
            <ProfileButton
              href={partner?.crmProfile}
            >
              Hubspot Profile
            </ProfileButton>
          </Stack>
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default ProfileCard;
